import createCancelAction from '../lib/create_cancel_action';
import RoutingGroup from 'models/routing_group';

export default createCancelAction(RoutingGroup);



// WEBPACK FOOTER //
// ./src/scripts/application/actions/routing_groups/cancel_routing_group.js